if (!customElements.get("image-text-tabs")) {
  customElements.define(
    "image-text-tabs",
    class ImageTextTabs extends HTMLElement {
      constructor() {
        super();

        this.detailsDisclosures = this.querySelectorAll("details-disclosure");

        this.boundOnMouseEnter = this.onMouseEnter.bind(this);
        this.boundOnToggle = this.onToggle.bind(this);

        this.addEventListener("mouseenter", this.boundOnMouseEnter, true);
        this.querySelectorAll("details").forEach((details) => {
          details.addEventListener("toggle", this.boundOnToggle);

          const summary = details.querySelector("summary");
          if (summary) {
            summary.addEventListener(
              "click",
              (event) => {
                if (details.open) event.preventDefault();
              },
              true, // 捕获阶段，早于默认行为执行
            );
          }
        });
      }

      disconnectedCallback() {
        // 移除组件级监听
        if (this.boundOnMouseEnter)
          this.removeEventListener("mouseenter", this.boundOnMouseEnter, true);

        // 移除每个 details 的监听
        if (this.boundOnToggle)
          this.querySelectorAll("details").forEach((details) => {
            details.removeEventListener("toggle", this.boundOnToggle);
          });
      }

      onMouseEnter(event) {
        const detailsDisclosure = event.target.closest("details-disclosure");
        if (!detailsDisclosure || !this.contains(detailsDisclosure)) return;

        this.openTab(detailsDisclosure);
        this.closeAllTabs(detailsDisclosure);
      }

      onToggle(event) {
        const details = event.currentTarget;
        this.handleTabToggle(details);
      }

      /**
       * Open a specific tab
       * @param {Element} detailsDisclosure
       */
      openTab(detailsDisclosure) {
        detailsDisclosure.open?.();
      }

      /**
       * Close all tabs
       */
      closeAllTabs(except) {
        this.detailsDisclosures.forEach((detailsDisclosure) => {
          if (detailsDisclosure !== except) detailsDisclosure.close?.();
        });
      }

      /**
       * Handle tab toggle event
       * @param {Element} details
       */
      handleTabToggle(details) {
        // 获取对应的图片
        const tabImage = this.querySelector(
          `.tab-image[data-index="${details.dataset.index}"]`,
        );
        if (!tabImage) return;

        if (details.open) {
          tabImage.classList.remove("hidden");
        } else {
          tabImage.classList.add("hidden");
        }
      }
    },
  );
}
